import http from "../services/api/http";
import { loadConfig } from "../services/appConfigService";
import ITenantInfo from "../models/TenantInfo";
import { getCurrentTenantSelection } from "../services/authService/storage";

const CmpAppId = "42C509AB-4714-4DC5-A2F7-7D2DE0D1C494";


export async function getTenantInstallations() {
  const config = await loadConfig();
  const url = config.apiUrl.segment(`Global/tenantinstallations(${CmpAppId})`).toString();
  let { data } = await http.get<ITenantInfo[]>(url);
  //data = []; // [data[0]];
  return data.sort((t1, t2) => t1.InstallationName.localeCompare(t2.InstallationName));
}


export function getCurrentTenantInstallationId() {
  const ti = getCurrentTenantSelection();
  return (ti && ti.RecordId) || undefined;
}
